import React, {useEffect, useState} from "react";
import localStyles from "./styles.module.scss";
import Button from "../Button";
import {useMediaQuery} from "react-responsive";
// import CreatePhotoReport from "../../pages/Dashboard/CreatePhotoReport";
import Modal from "../Modal";
import {AuthService} from "../../services/auth.service";
import {useNavigate} from "react-router-dom";
import {ROUTES} from "../../utils/constants";
import i18n from "i18next";
import translate from "../../utils/translate";
import {useAppDispatch, useAppSelector} from "../../storage/hooks";
import {setLang} from "../../storage/global";
import {setLocalStorageLang} from "../../utils/methods";
import {useGetLinksQuery} from "../../storage/api";
import CreatePhotoReport from "../../pages/Dashboard/CreatePhotoReport/CreatePhotoReport";

const Header = () => {
    const authService = new AuthService();
    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const isMobile: boolean = useMediaQuery({query: `(max-width: 640px`});
    const [username, setUsername] = useState<string>("");
    const [showUploadFileModal, setShowUploadFileModal] = useState<boolean>(false);

    const lang = useAppSelector(state => state.global.lang)
    const {data: links, refetch: refetchLinks, } = useGetLinksQuery();

    useEffect(() => {
        refetchLinks()
    }, [lang]);

    useEffect(() => {
        const username: string = localStorage.getItem("username");
        setUsername(username)
    }, []);

    function handleLang(lang: string) {
        i18n.changeLanguage(lang);
        dispatch(setLang(lang))
        setLocalStorageLang(lang)
    }

    const addButton = (<Button
        id={"add"}
        click={() => {setShowUploadFileModal(true)}}
        size={isMobile ? "large" : "middle"}
        background={"bg-green"}
        text={translate('add')}
        type={"button"}
        classes={`text-capitalize ${localStyles.addButton}`}
        appendBefore={
            <svg xmlns="http://www.w3.org/2000/svg"
                 width="24"
                 height="24"
                 fill="none"
                 id="plus">
                <path fill="#fff"
                      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM11 8a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8Z"
                />
            </svg>
        }
    />);

    return (<div className={localStyles.header}>
        <div className={`container ${localStyles.container}`}>

            <Button
                id={"logout"}
                size={"middle"}
                background={"bg-outline"}
                text={isMobile ? "" : translate('logout')}
                click={() => {
                    authService.logout().then(() => {
                        navigate("/" + ROUTES.SIGN_IN);
                    });
                }}
                styles={isMobile
                    ? {
                        width: "unset",
                        minWidth: "unset",
                    }
                    : null}
                type={"button"}
                classes={`text-capitalize ${localStyles.logoutButton}`}
                appendBefore={
                    <svg xmlns="http://www.w3.org/2000/svg"
                         fill="none"
                         height="24"
                         viewBox="0 0 24 24"
                         width="24"
                    >
                        <path
                            d="M17 16L21 12M21 12L17 8M21 12L7 12M13 16V17C13 18.6569 11.6569 20 10 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H10C11.6569 4 13 5.34315 13 7V8"
                            stroke="#000"
                        />
                    </svg>
                }
            />
            <p className={localStyles.username}>{username}</p>
            <div className={'d-flex'} style={{gap: '1rem'}}>
                <Button id={'en'}
                        size={'small'}
                        disabled={lang === 'en'}
                        background={lang === 'en' ? 'bg-green' : 'bg-outline'}
                        text={'EN'}
                        click={() => handleLang('en')}
                />
                <Button id={'cn'}
                        size={'small'}
                        disabled={lang === 'cn'}
                        background={lang === 'cn' ? 'bg-green' : 'bg-outline'}
                        text={'CN'}
                        click={() => handleLang('cn')}
                />
            </div>
            {/*{!isMobile && addButton}*/}
        </div>
        {/*{isMobile && addButton}*/}
        <Modal show={showUploadFileModal}
               headerClasses={'d-none'}
               width={560}
               element={<CreatePhotoReport close={() => setShowUploadFileModal(false)}/>}
               handleClose={setShowUploadFileModal} />
    </div>)
}

export default Header;
